import request from '@/utils/request'

const url = '/home/businessorders/'
const api = {
  getUserList (data) {
    return request({
      url: url + 'getUserList',
      method: 'post',
      data
    })
  },
  getBusinessOrdersList (data) {
    return request({
      url: url + 'getBusinessOrdersList',
      method: 'post',
      data
    })
  },
  getBusinessOrdersListCard (data) {
    return request({
      url: url + 'getBusinessOrdersListCard',
      method: 'post',
      data
    })
  },
  importBusOrder (data) {
    return request({
      url: url + 'importBusOrder',
      method: 'post',
      data
    })
  },
  changeIscomplete (data) {
    return request({
      url: url + 'changeIscomplete',
      method: 'post',
      data
    })
  },
  handleDelete (data) {
    return request({
      url: url + 'handleDelete',
      method: 'post',
      data
    })
  },
  saveBusinessOrders (data) {
    return request({
      url: url + 'saveBusinessOrders',
      method: 'post',
      data
    })
  },
  searchGoods (data) {
    return request({
      url: url + 'searchGoods',
      method: 'post',
      data
    })
  },
  getScreenBusOrdersList (data) {
    return request({
      url: url + 'getScreenBusOrdersList',
      method: 'post',
      data
    })
  },
  getBusOrdersQueryData (data) {
    return request({
      url: url + 'getBusOrdersQueryData',
      method: 'post',
      data
    })
  },
  changUser (data) {
    return request({
      url: url + 'changUser',
      method: 'post',
      data
    })
  },
  getDetail (data) {
    return request({
      url: url + 'getDetail',
      method: 'post',
      data
    })
  },
  export (data) {
    return request({
      url: url + 'export',
      method: 'post',
      data
    })
  },
  export1 (data) {
    return request({
      url: url + 'export1',
      method: 'post',
      data
    })
  },
  filterDate (data) {
    return request({
      url: url + 'filterdate',
      method: 'post',
      data
    })
  },
  getFactory (data) {
    return request({
      url: url + 'getFactory',
      method: 'post',
      data
    })
  }
}
export default api



// WEBPACK FOOTER //
// ./src/api/businessOrders.js